import React, { useEffect, useState } from "react"
import DefaultActions from "./DefaultActions"
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  SelectField,
  SelectInput,
  Edit,
  SimpleForm,
  Create,
  required,
  DateField,
  DateInput,
  useRecordContext,
  FormDataConsumer,
} from "react-admin"
import DefaultPagination from "./DefaultPagination"
import getHttpsCallable from "../utils/getHttpsCallable"

const answerTypes = [
  { id: "template", name: "Whatsapp Template" },
  { id: "text", name: "Plain Text" },
]

const statusChoices = [
  { id: "active", name: "Active" },
  { id: "disabled", name: "Disabled" },
]

const logicChoices = [
  { id: null, name: "No action" },
  { id: "disableAccount", name: "Disable account" },
]

const getTemplates = getHttpsCallable("admin-getTemplates")

export function AutomaticAnswersList ({ ...props }) {
  return (
    <List
      {...props}
      actions={<DefaultActions />}
      perPage={15}
      pagination={<DefaultPagination />}
    >
      <Datagrid rowClick='show'>
        <TextField component="pre" source='incomingMsg'
          label='Incoming message'  sortable={false} />
        <SelectField source="status" label='Status' choices={statusChoices} />
        <DateField source="deactivateAnswerAt" label="Deactivation date" />
        <SelectField source="logic" label='Action on incoming message'
          choices={logicChoices} />
      </Datagrid>
    </List>
  )
}


export function AutomaticAnswersEdit ({...props}) {
  const [whatsappTemplates, setWhatsappTemplates] = useState([])
  const [fetch, setFetch] = useState(true)
  const record = useRecordContext()

  useEffect(() => {
    async function getAllTemplates () {
      const whatsapp = await getTemplates({
        type: "whatsapp",
        label: "all",
      })

      setWhatsappTemplates(whatsapp?.data)
      setFetch(false)
    }

    if (fetch) {
      getAllTemplates()
    }
  }, [whatsappTemplates, fetch])

  return (
    <Edit {...props}>
      <SimpleForm>
        <TextInput multiline component="pre" source='incomingMsg'
          label='Incoming message' sortable={false} validate={[required()]} />
        <SelectInput
          source="answerType"
          label='Type'
          choices={answerTypes}
        />
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            if (formData.answerType === "template") {
              return <SelectInput
                label='Template'
                source="templateName"
                translateChoice={false}
                choices={
                  Object
                    .values(whatsappTemplates)
                    .map((template: Template) =>
                      ({ id: template.name, name: template.userDefinedName }))
                    
                }
                validate={(value: any, allValues: any) => {
                  if (!value && allValues.answerType === "template") {
                    return "Required"
                  }
                  return undefined
                }}
                {...rest}
              />
            }
            
            return <TextInput
              multiline
              component="pre"
              source='automaticAnswer'
              label='Automatic answer'
              sortable={false}
              validate={(value, allValues) => {
                if (!value && allValues.answerType !== "template") {
                  return "Required"
                }
                return undefined
              }}
              {...rest}
            />
          }}
        </FormDataConsumer>
        <SelectInput source="status" label='Status' choices={statusChoices} />
        <DateInput source="deactivateAnswerAt" label="Deactivation date" />
        <SelectInput source="logic" label='Action on incoming message'
          choices={logicChoices} />
      </SimpleForm>
    </Edit>
  )
}


export function AutomaticAnswersCreate ({...props}) {
  const [whatsappTemplates, setWhatsappTemplates] = useState([])
  const [fetch, setFetch] = useState(true)

  useEffect(() => {
    async function getAllTemplates () {
      const whatsapp = await getTemplates({
        type: "whatsapp",
        label: "all",
      })

      setWhatsappTemplates(whatsapp?.data)
      setFetch(false)
    }

    if (fetch) {
      getAllTemplates()
    }
  }, [whatsappTemplates, fetch])

  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput multiline component="pre" source='incomingMsg'
          label='Incoming message' sortable={false} validate={[required()]}
        />
        <SelectInput
          source="answerType"
          label='Type'
          choices={answerTypes}
        />
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            if (formData.answerType === "template") {
              return <SelectInput
                label='Template'
                source="templateName"
                translateChoice={false}
                choices={
                  Object
                    .values(whatsappTemplates)
                    .map((template: Template) =>
                      ({ id: template.name, name: template.userDefinedName }))
                    
                }
                validate={(value: any, allValues: any) => {
                  if (!value && allValues.answerType === "template") {
                    return "Required"
                  }
                  return undefined
                }}
                {...rest}
              />
            }
            
            return <TextInput
              multiline
              component="pre"
              source='automaticAnswer'
              label='Automatic answer'
              sortable={false}
              validate={(value, allValues) => {
                if (!value && allValues.answerType !== "template") {
                  return "Required"
                }
                return undefined
              }}
              {...rest}
            />
          }}
        </FormDataConsumer>
        <SelectInput source="status" label='Status'
          choices={statusChoices} initialValue='disabled' />
        <DateInput source="deactivateAnswerAt" label="Deactivation date" />
        <SelectInput source="logic" label='Action on incoming message'
          choices={logicChoices} />
      </SimpleForm>
    </Create>
  )
}
